import { render, staticRenderFns } from "./EducationExamsExam.vue?vue&type=template&id=0e858f36&"
import script from "./EducationExamsExam.vue?vue&type=script&lang=js&"
export * from "./EducationExamsExam.vue?vue&type=script&lang=js&"
import style0 from "./EducationExamsExam.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports